module.exports = __webpack_public_path__ + "static/img/service_introduce_5123_zh_h5.4716bb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5123_zh_h5.png
// module id = 12XK
// module chunks = 34